export default __webpack_public_path__ + "KaTeX_Main-Regular.9e75cd605a0f61540bc6894c330f1ef5.woff";